import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Space, Tag, Button } from 'antd';

export default function DashboardFilterBar({ filters = [] }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const active = filters.filter((f) => searchParams.get(f.key));

  if (active.length === 0) return null;

  const clearAll = () => {
    const next = new URLSearchParams(searchParams);
    active.forEach((f) => next.delete(f.key));
    navigate({ search: next.toString() ? `?${next.toString()}` : '' }, { replace: true });
  };

  const clearOne = (key) => {
    const next = new URLSearchParams(searchParams);
    next.delete(key);
    navigate({ search: next.toString() ? `?${next.toString()}` : '' }, { replace: true });
  };

  return (
    <div className="dashboard-filter-bar">
      <Space wrap>
        {active.map((f) => (
          <Tag
            key={f.key}
            closable
            onClose={() => clearOne(f.key)}
            color="blue"
          >
            {f.label}: {searchParams.get(f.key)}
          </Tag>
        ))}
        <Button type="link" size="small" onClick={clearAll}>
          View all
        </Button>
      </Space>
    </div>
  );
}
